module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 5
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_musicmall_focus/124141.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("陈粒在蓬莱")])])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 8
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124253.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("中年贾跃亭和朴树，都在为钱奔波")])])]), _vm._v(" "), _c('section', {
    staticClass: "bottom"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 7
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124060.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("歌都不会唱当什么超级英雄")])])]), _vm._v(" "), _c('section', {
    staticClass: "left bottom"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 9
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124219.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("我欲渡你成佛，却被你渡成魔")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("专栏")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2239ff97"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzhuanlang.vue
// module id = 245
// module chunks = 0